import { get, post } from "../httpInterceptor";

//fetching id,segcode,segdescription from api,listing data
export const getAllSegment = () => {
  return get(`/sarvagram-credit/masternew/getsegmentmaster`).then((res) => {
    console.log("RESPONSE :: getAllSegment ::: ", res);
    return res;
  });
};
